import { Outlet } from "react-router-dom";

export const UsersPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
